// extracted by mini-css-extract-plugin
module.exports = {"commentaries":"search_result_commentaries-module__commentaries--1sUcy"};